import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  containerBurger: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "auto 0",
    minHeight: 20
},
  lineBurger: {
    width: 40,
    border: "2px solid #173760",
    borderRadius: 50,
  },

  burgerMenuToggler: {
    display: "none",
    "@media screen and (max-width: 480px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 2px"
    }
  },

  mobileMenu: {
    display: "none",
    "@media screen and (max-width: 480px)": {
      display: "block",
      zIndex: 10,
      background: "white",
      //padding: "0 8px",
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",

      '& .MuiBox-root': {
        maxWidth: "none"
      }
    }
  },
}));

export default useStyles;
